// test728
(728 && 0);
